import PhotosList from "./PhotosList";
import { BsXOctagonFill } from "react-icons/bs";
import { useDeleteAlbumMutation, useAddPhotoMutation } from "../store";
import { faker } from "@faker-js/faker";

const Album = ({ children }) => {
  // console.log(children)
  // console.log(useDeleteAlbumMutation());
  const [deleteAlbum, results] = useDeleteAlbumMutation();
  const handleDeleteAlbum = (e) => {
    // delete album
    deleteAlbum(children);
  };

  const deleteButton = (
    <BsXOctagonFill
      onClick={handleDeleteAlbum}
      className="mr-2 cursor-pointer"
    ></BsXOctagonFill>
  );

  let contentDeleteButton;
  // console.log(results);
  if (results.isLoading) {
    contentDeleteButton = "...";
  } else if (results.isError) {
    contentDeleteButton = (
      <>
        <div className="mr-2">Error deleting item</div>
        {deleteButton}
      </>
    );
  } else {
    contentDeleteButton = deleteButton;
  }

  // console.log(useAddPhotoMutation());
  const [addPhoto, resultsPhoto] = useAddPhotoMutation();
  const handleAddPhoto = (e) => {
    // add photo to album
    let photo = {
      albumId: children.id,
      url: faker.image.urlPicsumPhotos({ width: 208, height: 144 }),
    };
    // console.log(addPhoto);
    console.log(addPhoto(photo));
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center">
          {contentDeleteButton}
          <span>Album {children.name}</span>
        </div>
        <div>
          <button onClick={handleAddPhoto} className="p-2 border">
            Add Photo
          </button>
        </div>
      </div>
      <PhotosList album={children}></PhotosList>
    </div>
  );
};

export default Album;
